import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ErrorHandler, NgModule, inject, provideAppInitializer } from '@angular/core';
import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { ServiceWorkerModule } from '@angular/service-worker';
import { BsModalService, ModalModule } from 'ngx-bootstrap/modal';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { environment } from '../environments/environment';
import { AngularMaterialModule } from './angular-material/angular-material.module';
import { AppComponent } from './app.component';
import { AppConfig } from './app.config';
import { ROUTES } from './app.routes';
import { HttpErrorHandler } from './error-handlers/error-handler-service';
import { MessageService } from './error-handlers/message-service';
import { ErrorComponent } from './error/error.component';
import { DevModeBadgeComponent } from './layout/dev-mode-badge/dev-mode-badge.component';
import { ToasterComponent } from '../modules/primitives/toasts/components/toaster/toaster.component';
import { DxcDialogHostComponent, DxcTourHostComponent } from '../modules/primitives/dxc';
import { Microservices } from './microservices';
import { TelemetryService } from './@core/telemetry/telemetry.service';
import { TelemetryErrorHandler } from './@core/telemetry/telemetry-error-handler';
import { MainService, ConstantsService, ListenerService, MapsService, ObservablesService, PastDataService, RouterService } from '@services';
import { registerLocaleData } from '@angular/common';
import localeEsMx from '@angular/common/locales/es-MX';

registerLocaleData(localeEsMx);


// import {IConfig, NgxMaskModule} from 'ngx-mask';

const APP_PROVIDERS = [
  AppConfig
];

// export const options: Partial<IConfig> | (() => Partial<IConfig>) = null;

@NgModule({ bootstrap: [AppComponent],
    declarations: [
        AppComponent,
        ErrorComponent,
        DevModeBadgeComponent,
    ], imports: [BrowserModule,
        CommonModule,
        BrowserAnimationsModule,
        AngularMaterialModule,
        FormsModule,
        ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
        ModalModule,
        BsDatepickerModule,
        RouterModule.forRoot(ROUTES, {
            useHash: true
        }),
        TabsModule,
        ToasterComponent,
        DxcDialogHostComponent,
        DxcTourHostComponent
        // NgxMaskModule.forRoot(options)
    ], providers: [
        APP_PROVIDERS,
        MainService,
        ListenerService,
        PastDataService,
        ConstantsService,
        RouterService,
        BsModalService,
        Microservices,
        MapsService,
        ObservablesService,
        AngularMaterialModule,
        HttpErrorHandler,
        MessageService,
        provideHttpClient(withInterceptorsFromDi()),
        // Telemetría de uso: arranca con la app y registra los errores que se escapan. Apagada, `start()` no hace nada.
        provideAppInitializer(() => inject(TelemetryService).start()),
        { provide: ErrorHandler, useClass: TelemetryErrorHandler },
        // El CDK 21 muestra cada overlay como `popover` nativo, es decir en la
        // **capa superior** del navegador. Ahí no manda el z-index: un elemento
        // de la capa superior se pinta encima de TODO el documento, valga 1100
        // o 2 147 483 647. Y eso deja bajo cualquier `MatDialog` abierto a las
        // tres capas que el sistema pone encima —el diálogo bloqueante, la
        // notificación y la espera—, además del `.pac-container` de Google y de
        // los paneles heredados que se anclan a `<body>`.
        //
        // Se veía al alta de conductor: la confirmación se abría, su velo teñía
        // la página… y quedaba DETRÁS del formulario que la había pedido, así
        // que no había forma de contestarla ni de salir. Medido en el navegador:
        // el velo en 10100 contra un contenedor de overlays en 9999, y aun así
        // `elementFromPoint` sobre el centro del diálogo devolvía el formulario.
        // El z-index no era el problema; `:popover-open` sí.
        //
        // `usePopover: false` es la vía oficial del CDK para volver al apilado
        // por z-index, que es el modelo que esta base de código lleva escrito de
        // punta a punta. Se apaga aquí, para todos los overlays, y no vista por
        // vista: la mitad apagada sería la peor de las dos.
        { provide: OVERLAY_DEFAULT_CONFIG, useValue: { usePopover: false } },
    ] })
export class AppModule { }
